import React from 'react'
import { useToast, Text, VStack, Table, Thead, Tbody, Th, Tr, Td } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  Card,
  Page,
  PageHeader,
  ButtonEdit,
  ButtonDelete,
  FieldList,
  FieldListItem
} from 'components'

import { QuestionType } from '../enums'

import { useQuestionDetailQuery, useQuestionDeleteMutation } from '../hooks'

export const QuestionDetailPage = props => {
  const toast = useToast()
  const navigate = useNavigate()
  const { questionId } = useParams()
  const { data, loading } = useQuestionDetailQuery(questionId)
  const [questionDelete] = useQuestionDeleteMutation(questionId)

  const handleBack = () => navigate('..')
  const handleEdit = () => navigate('editar')
  const handleDelete = async () => {
    await questionDelete()
    toast({
      status: 'success',
      title: 'Questão eliminada.',
      description: 'A questão foi eliminada com sucesso.'
    })
    navigate('..')
  }

  return (
    <Page>
      <PageHeader heading={`Questão #${questionId}`} onBack={handleBack}>
        <ButtonDelete onClick={handleDelete} />
        <ButtonEdit onClick={handleEdit} />
      </PageHeader>

      <VStack align='stretch'>
        <Card heading='Detalhes'>
          <FieldList isLoading={loading} isReadOnly={true}>
            <FieldListItem label='Texto'>
              <Text>{data?.text}</Text>
            </FieldListItem>

            <FieldListItem label='Texto (tempo verbal futuro)'>
              <Text>{data?.textFuture}</Text>
            </FieldListItem>

            <FieldListItem label='Explicação'>
              <Text>{data?.description}</Text>
            </FieldListItem>

            <FieldListItem label='Sugestão de leitura'>
              <Text>{data?.associatedLink}</Text>
            </FieldListItem>

            <FieldListItem label='Dimensão'>
              <Text>{data?.dimension.name}</Text>
            </FieldListItem>

            <FieldListItem label='Tipo'>
              <Text>{QuestionType.toString(data?.type)}</Text>
            </FieldListItem>

            <FieldListItem label='Limiar'>
              <Text>{data?.threshold}</Text>
            </FieldListItem>

            <FieldListItem label='Permite N/A'>
              <Text>{data?.notApplicable ? 'Sim' : 'Não'}</Text>
            </FieldListItem>
          </FieldList>
        </Card>

        {data?.type === QuestionType.MULTIPLE && (
          <Card heading='Opçōes de múltipla escolha'>
            <FieldList isLoading={loading}>
              {data?.options.map((option, index) => (
                <FieldListItem key={index} label={`Opção ${index + 1}`}>
                  <Text>{option.value}</Text>
                </FieldListItem>
              ))}
            </FieldList>
          </Card>
        )}

        <Card heading='Recomendaçōes'>
          <VStack>
            <Table>
              <Thead>
                <Tr>
                  <Th>
                    <Text textAlign='center'>Fase</Text>
                  </Th>
                  <Th>
                    <Text textAlign='center'>Abaixo do limiar</Text>
                  </Th>
                  <Th>
                    <Text textAlign='center'>Acima do limiar</Text>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.recommendations.map(({ stage, bellow, above }, index) => (
                  <Tr key={index}>
                    <Td>
                      <Text fontWeight='bold' textAlign='end'>
                        {stage.name}
                      </Text>
                    </Td>
                    <Td>
                      <Text>{bellow}</Text>
                    </Td>
                    <Td>
                      <Text>{above}</Text>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </VStack>
        </Card>
      </VStack>
    </Page>
  )
}

export default QuestionDetailPage
